import gql from "graphql-tag";
import GraphQLClient, { RequestParam } from "../api";
import { NovelGroup } from "../models";

interface INovelGroupClient {
  fetchAllGroups: () => Promise<NovelGroup[]>;
  createGroup: (name: string) => Promise<NovelGroup>;
  updateGroup: (groupId: string, payload: { name?: string; novelKeys?: string[] }) => Promise<NovelGroup>;
  deleteGroup: (groupId: string) => Promise<NovelGroup>;
}

export class NovelGroupClient implements INovelGroupClient {
  async fetchAllGroups(): Promise<NovelGroup[]> {
    const { novelGroups } = await GraphQLClient.request({ query: fetchAllGroups });
    return novelGroups;
  }

  async createGroup(name: string): Promise<NovelGroup> {
    const params: RequestParam = {
      query: createNovelGroup,
      variables: {
        input: { name },
      },
    };
    const { createNovelGroup: result } = await GraphQLClient.request(params);
    return result;
  }

  async updateGroup(groupId: string, payload: { name?: string; novelKeys?: string[] }): Promise<NovelGroup> {
    const params: RequestParam = {
      query: updateNovelGroup,
      variables: {
        input: { groupId, ...payload },
      },
    };
    const { updateNovelGroup: result } = await GraphQLClient.request(params);
    return result;
  }

  async deleteGroup(groupId: string): Promise<NovelGroup> {
    const params: RequestParam = {
      query: deleteNovelGroup,
      variables: { groupId },
    };
    const { deleteNovelGroup: result } = await GraphQLClient.request(params);
    return result;
  }
}

/**
 * Query
 */

const fetchAllGroups = gql`
  query NovelGroups {
    novelGroups {
      groupId
      name
      novelKeys
      createdAt
      updatedAt
    }
  }
`;

/**
 * Mutation
 */

const createNovelGroup = gql`
  mutation CreateNovelGroup($input: CreateNovelGroupInput!) {
    createNovelGroup(input: $input) {
      groupId
      name
      novelKeys
      createdAt
      updatedAt
    }
  }
`;

const updateNovelGroup = gql`
  mutation UpdateNovelGroup($input: UpdateNovelGroupInput!) {
    updateNovelGroup(input: $input) {
      groupId
      name
      novelKeys
      createdAt
      updatedAt
    }
  }
`;

const deleteNovelGroup = gql`
  mutation DeleteNovelGroup($groupId: ID!) {
    deleteNovelGroup(groupId: $groupId) {
      groupId
      name
      novelKeys
      createdAt
      updatedAt
    }
  }
`;
